import React from 'react';
import { CategoriaTorneio } from '../../../services/categoriaTorneioService';
import { FaseGrupoPartidasLite } from '../../../services/faseGrupoPartidasService';
import { LinhaClassificacaoFront } from '../../../services/classificacaoService';
import GrupoPrintSection from './GrupoPrintSection';
import ChavePrintSection from './ChavePrintSection';
import './print.css';

interface CategoriaPrintPageProps {
  categoria: CategoriaTorneio;
  gruposPorFase: Map<string, FaseGrupoPartidasLite[]>;
  classificacaoPorGrupo?: Record<string, LinhaClassificacaoFront[]>;
}

const CategoriaPrintPage: React.FC<CategoriaPrintPageProps> = ({
  categoria,
  gruposPorFase,
  classificacaoPorGrupo,
}) => {
  const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    const day = days[date.getDay()];
    const dayNum = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    return `${day}, ${dayNum}/${month}`;
  };

  const formatDateRange = (): string => {
    const inicio = formatDate(categoria.torneio.dataInicio);
    const fim = formatDate(categoria.torneio.dataFim);
    if (inicio && fim) {
      return `${inicio} a ${fim}`;
    }
    if (inicio) return inicio;
    if (fim) return fim;
    return '';
  };

  const fasesGrupo = categoria.fasesCategoria
    .filter(f => f.tipoGrupoChave === 'GRUPO')
    .sort((a, b) => a.ordem - b.ordem);

  const fasesChave = categoria.fasesCategoria
    .filter(f => f.tipoGrupoChave === 'CHAVE')
    .sort((a, b) => a.ordem - b.ordem);

  return (
    <div className="print-container">
      <div className="print-header">
        <h1>{categoria.torneio.nome}</h1>
        <h2>{categoria.nome}</h2>
        {categoria.torneio.dataInicio && (
          <p>Período: {formatDateRange()}</p>
        )}
        {categoria.torneio.local && (
          <p>
            Local: {categoria.torneio.local.nome}
            {categoria.torneio.local.endereco && (
              <> - {categoria.torneio.local.endereco.logradouro}, {categoria.torneio.local.endereco.numero}</>
            )}
            {categoria.torneio.local.endereco?.cidade && (
              <> - {categoria.torneio.local.endereco.cidade.nome}/{categoria.torneio.local.endereco.cidade.uf}</>
            )}
          </p>
        )}
      </div>

      {/* Fases de Grupo */}
      {fasesGrupo.map(fase => {
        const grupos = gruposPorFase.get(fase.id) || [];
        if (grupos.length === 0) return null;
        return (
          <GrupoPrintSection
            key={fase.id}
            fase={fase}
            grupos={grupos}
            classificacaoPorGrupo={classificacaoPorGrupo}
          />
        );
      })}

      {/* Fases de Eliminação */}
      {fasesChave.map(fase => (
        <ChavePrintSection key={fase.id} fase={fase} />
      ))}
    </div>
  );
};

export default CategoriaPrintPage;

